import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { assertString } from "../../../utils/assertPrimitive";
import { CALL_SVG, MOBILE_SVG } from "../../../utils/svgs";
import { AppBottomSheet } from "../../Generic/AppBottomSheet";
import { AppBoxActionCard } from "../../Generic/AppBoxActionCard";
import { AppBoxActionCards } from "../../Generic/AppBoxActionCards";
import { AppOverlay } from "../../Generic/AppOverlay";
import { If } from "../../Generic/If";

interface Props {
  isOpen: boolean;
  homePhone: string | null;
  mobilePhone: string | null;
  onClickPhone: (phone: string) => void;
  onRequestClose: () => void;
}

const CallPatientBottomSheet = (props: Props) => {
  const hasNoPhone = props.homePhone === null && props.mobilePhone === null;
  const hasTwoPhones = props.homePhone !== null && props.mobilePhone !== null;

  const handleClickHomePhone = React.useCallback(
    () => props.onClickPhone.call(null, assertString(props.homePhone)),
    [props.onClickPhone, props.homePhone]
  );

  const handleClickMobilePhone = React.useCallback(
    () => props.onClickPhone.call(null, assertString(props.mobilePhone)),
    [props.onClickPhone, props.mobilePhone]
  );

  return (
    <AppOverlay>
      <AppBottomSheet
        isOpen={props.isOpen}
        className="CallPatientBottomSheet"
        rounded={true}
        title={hasTwoPhones ? translate(STRINGS.HOW_WOULD_YOU_LIKE_TO_CALL_THE_PATIENT) : undefined}
        onRequestClose={props.onRequestClose}
      >
        <AppBoxActionCards>
          <If condition={hasNoPhone}>
            <AppBoxActionCard
              className="Soft"
              icon={CALL_SVG}
              label={translate(STRINGS.THIS_PATIENT_HAS_NO_PHONE_NUMBERS)}
              onClick={() => null}
            />
          </If>
          <If condition={props.homePhone !== null}>
            <AppBoxActionCard
              icon={CALL_SVG}
              label={translate(STRINGS.CALL_HOME)}
              onClick={handleClickHomePhone}
            />
          </If>
          <If condition={props.mobilePhone !== null}>
            <AppBoxActionCard
              icon={MOBILE_SVG}
              label={translate(STRINGS.CALL_MOBILE)}
              onClick={handleClickMobilePhone}
            />
          </If>
        </AppBoxActionCards>
      </AppBottomSheet>
    </AppOverlay>
  );
};

export default React.memo(CallPatientBottomSheet);
